import { useEffect, useState } from "react";

/**
 * Paint the collapsed "from" state first, then flip on the next frame so the
 * enter transition runs. useEffect (not useLayoutEffect) so that paint commits
 * before we schedule the reveal.
 */
const useOverflowRevealAnimation = (expanded: boolean) => {
  const [isRevealVisible, setIsRevealVisible] = useState(false);

  useEffect(() => {
    if (!expanded) {
      return;
    }

    const animationFrameId = window.requestAnimationFrame(() => {
      setIsRevealVisible(true);
    });

    return () => window.cancelAnimationFrame(animationFrameId);
  }, [expanded]);

  return isRevealVisible;
};

export { useOverflowRevealAnimation };
